export default __webpack_public_path__ + "33f769fa4e847a81f6ceb4df9c44deb5.png";